<template>

    <el-row class="bottom20"  v-if="tableData != null">

        <el-row class="column-name" justify="start">
            <span>{{tableTitle}}</span>
            <div class="navbar-right">
                得分：{{getAddSubScore(tableData)}}&nbsp&nbsp
                <el-button type="info" v-if="canOper" plain size="minimum" @click="openAddsubDialog">操作</el-button>
            </div>
        </el-row>
        <el-row class="bottom20">
            <el-table :data="tableData">
                <el-table-column prop="config.desc" label="项目">
                </el-table-column>
                <el-table-column label="分值">
                    <template slot-scope="scope">
                        {{ Math.abs(Number.parseFloat(scope.row.score)) }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注">
                </el-table-column>
            </el-table>
        </el-row>

        <addsub-record-dialog :tableData="tableData" :title="tableTitle" :addsubRecordDialogVisible.sync="addsubRecordDialogVisible" @afterCloseAddsubRecordDialog="afterCloseAddsubRecordDialog"></addsub-record-dialog>

    </el-row>

</template>

<script>

    import AddsubRecordDialog from './addsubRecordDialog'

    export default {
        name: "addsubRecordTable",

        props: ['tableData', 'type', 'canOper'],

        components: {
            AddsubRecordDialog,

        },

        data() {
            return {
                addsubRecordDialogVisible: false,
            }
        },

        methods: {

            openAddsubDialog() {
                this.addsubRecordDialogVisible = true;
            },

            afterCloseAddsubRecordDialog(){
                this.addsubRecordDialogVisible = false;
                this.$emit('afterUpdateAddsubRecord');
            },

            getAddSubScore(tableData) {
                let addSubScore = tableData.reduce(function (sum, item) {
                    if (item.score != '') {
                        return Number.parseFloat(sum) + Number.parseFloat(item.score);
                    } else {
                        return Number.parseFloat(sum);
                    }
                }, 0);
                return Math.round(addSubScore * 100) / 100;
            }
        },

        computed: {

            tableTitle() {
                if (this.type == 'add') {
                    return '加分项';
                } else if (this.type == 'sub') {
                    return '减分项';
                } else {
                    return '';
                }
            },

            tableColName() {
                if (this.type == 'add') {
                    return '增加分值';
                } else if (this.type == 'sub') {
                    return '扣减分值';
                } else {
                    return '';
                }
            },

        }


    }
</script>

<style scoped>

</style>